import React from 'react';

function getMatchDetailsText(game) {
    let text;

    if(game.status == 3) {
        text = getByLang('end','סיום','نهاية');
    } else if(game.status == 2) {
        text = game.currentMinute ? "'" + game.currentMinute: getByLang('playing','משוחק','تلعب');
    } else if(game.status== 4) {
        text = getByLang('TBD','טרם נקבע','لم تحدد بعد');
    } else {
        //Pre match
        text = game.stringDate;
        text = typeof game.hour != 'undefined' && game.hour ? text + ' | ' + game.hour : text;
    }
    
    return text;
}

function getGameLink(game) {
    let link = "/game/"+game.id;

    if(lang == 'en') {
        link = "/en/game/"+game.id;
    } else if(lang == 'ar') {
        link = "/ar/game/"+game.id;
    }

    return link;
}

const GameLiveScore = ({
    game
}) =>  {
    return (       
        <li className="singleScore" style={{"width": "175px", "marginRight": "5px", "marginLeft": "5px"}}>
            <a href={getGameLink(game)}>
                <i className={game.status == 2 ? "fa fa-circle live-game-" + game.id :  "fa fa-circle hidden live-game-" + game.id} aria-hidden="true" style={{"color": "green", "marginLeft": "5px"}}></i>
                <div className={ "matchDate live-game-" + game.id }>{getMatchDetailsText(game)}</div>
                <div className="teamNames">{ getObjField(game.homeTeamId) } - { getObjField(game.awayTeamId) }</div>
                <div className="scoresDivider"></div>
                <div className="headerScoreLine live-game-216834"> {game.homeScore} : {game.awayScore} </div>
            </a>
        </li>
    )};


                            
export default GameLiveScore